import { jsx as _jsx } from "react/jsx-runtime";
export const Media = ()=>/*#__PURE__*/ _jsx("span", {
        children: "Media dummy"
    });

//# sourceMappingURL=Media.js.map